import { appConfig } from "../app/config/appConfig";
import { postJson } from "./apiClient";

const serializeSpecObject = (value) => JSON.stringify(value, null, 2);

const looksLikeGeneratedSpec = (value) =>
  typeof value === "string" &&
  Boolean(value.trim()) &&
  (value.includes("\n") || value.trim().startsWith("openapi:") || value.trim().startsWith("{"));

const isOpenApiDocument = (value) =>
  Boolean(
    value &&
      typeof value === "object" &&
      typeof value.openapi === "string" &&
      (value.info || value.paths || value.components)
  );

const getGeneratedSpecFromObject = (response) => {
  const candidateKeys = [
    "spec",
    "generatedSpec",
    "generated_spec",
    "draft",
    "content",
    "yaml",
    "output",
    "openapi",
  ];

  for (const key of candidateKeys) {
    const value = response?.[key];

    if (typeof value === "string" && value.trim()) {
      if (key === "openapi" && !looksLikeGeneratedSpec(value)) {
        continue;
      }

      return value.trim();
    }

    if (isOpenApiDocument(value)) {
      return serializeSpecObject(value);
    }
  }

  return "";
};

const normalizeGeneratedSpec = (response) => {
  if (typeof response === "string") {
    return response.trim();
  }

  if (!response || typeof response !== "object") {
    return "";
  }

  if (isOpenApiDocument(response)) {
    return serializeSpecObject(response);
  }

  const directMatch = getGeneratedSpecFromObject(response);

  if (directMatch) {
    return directMatch;
  }

  if (response.result && typeof response.result === "object") {
    if (isOpenApiDocument(response.result)) {
      return serializeSpecObject(response.result);
    }

    return getGeneratedSpecFromObject(response.result);
  }

  return "";
};

export const generateSpecDraft = async ({ prompt }) => {
  const response = await postJson(appConfig.specGenerateUrl, {
    prompt,
  });
  const generatedSpec = normalizeGeneratedSpec(response);

  if (!generatedSpec) {
    throw new Error("The AI design service returned an empty specification.");
  }

  return generatedSpec;
};
